import Vue from 'vue';
import Router from 'vue-router';

import { Component } from '@/views/component';
import AppShell from '@/views/protected/AppShell';

import appAuth from './plugins/auth';

Vue.use(Router);
const option = {
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: Component.Auth.Login,
            component: () => import( /*webpackChunkName:"auth" */ '@/views/Login.vue'),
            meta: { title: 'LA:Login' },
        },
        {
            path: '/register',
            name: Component.Auth.Register,
            component: () => import( /*webpackChunkName:"auth" */ '@/views/Register.vue'),
            meta: { title: 'LA:Register' },
        },
        {
            path: '/reset-password',
            name: Component.Auth.ResetPassword,
            component: () => import( /*webpackChunkName:"auth" */ '@/views/ResetPassword.vue'),
            meta: { title: 'LA:ResetPassword' },
        },
        {
            path: '/change-password',
            name: Component.Auth.ChangePassword,
            component: () => import( /*webpackChunkName:"auth" */ '@/views/ChangePassword.vue'),
            meta: { title: 'LA:ChangePassword' },
        },
        {
            path: "/", name: "appshell", component: AppShell, meta: { requiresAuth: true }, children: [
                {
                    path: '/employee',
                    name: Component.Protected.Employee.Base,
                    component: () => import(/*webpackChunkName:"employee" */ '@/views/protected/employee/Employee.vue'),
                    meta: { title: 'LA:Employee' },
                },
                {
                    path: '/employee/myBenefits',
                    name: Component.Protected.Employee.MyBenefits,
                    component: () => import(/*webpackChunkName:"employee" */ '@/views/protected/employee/MyBenefits.vue'),
                    meta: { title: 'LA:MyInfo' },
                },
                {
                    path: '/employee/profile/:id',
                    name: Component.Protected.Employee.Profile,
                    component: () => import(/*webpackChunkName:"employee" */ '@/views/protected/employee/Profile.vue'),
                    meta: { title: 'LA:EmployeeProfile' },
                },
                {
                    path: '/employee/:id',
                    name: Component.Protected.Employee.Edit,
                    component: () => import(/*webpackChunkName:"employee" */ '@/views/protected/employee/Edit.vue'),
                    meta: { title: 'LA:EditEmployee' },
                },
                {
                    path: '/me',
                    name: Component.Protected.Employee.Me,
                    component: () => import(/*webpackChunkName:"employee" */ '@/views/protected/employee/Me.vue'),
                    meta: { title: 'LA:Me' },
                },
                {
                    path: '/tasks',
                    name: Component.Protected.Employee.MyTasks,
                    component: () => import(/*webpackChunkName:"tasks" */'@/views/protected/tasks/MyTasks.vue'),
                    meta: { title: 'La: My Tasks' },
                },
                {
                    path: '/dashboard',
                    name: Component.Protected.Dashboard,
                    component: () => import(/*webpackChunkName:"dashboard" */ '@/views/protected/Dashboard.vue'),
                    meta: { title: 'LA:Dashboard' },
                },
                {
                    path: '/timeOff/details/:id',
                    name: 'DetailsTimeOff',
                    component: () => import(/*webpackChunkName:"timeoff" */ '@/views/protected/timeoff/Detail.vue'),
                    meta: { title: 'LA:TimeoffDetails' },
                },
                {
                    path: '/timeOff/list',
                    name: 'ListTimeOff',
                    component: () => import(/*webpackChunkName:"timeoff" */ '@/views/protected/timeoff/List.vue'),
                    meta: { title: 'LA:ListTimeoff' },
                },
                {
                    path: '/timeOff/approve',
                    name: 'ApproveTimeOff',
                    component: () => import(/*webpackChunkName:"timeoff" */ '@/views/protected/timeoff/Approve.vue'),
                    meta: { title: 'LA:ApproveTimeoff' },
                },
                {
                    path: "/company",
                    name: "Company",
                    component: () => import(/* webpackChunkName: "company" */ "@/views/protected/company/Company.vue"),
                    meta: { title: "LA:Company" }
                },
                {
                    path: '/company/info',
                    name: 'CompanyInfo',
                    component: () => import(/* webpackChunkName: "company" */ '@/views/protected/company/general/Info.vue'),
                    meta: { title: 'LA:CompanyInfo' },
                },
                {
                    path: "/company/leaves",
                    name: "ListLeaveTypes",
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/leave/List.vue'),
                },
                {
                    path: '/company/leaves/add',
                    name: 'AddLeaveTypes',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/leave/Add.vue'),
                    meta: { title: 'LA:TimeoffTypes' },
                },
                {
                    path: '/company/leaves/:id',
                    name: 'EditLeaveTypes',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/leave/Edit.vue'),
                    meta: { title: 'LA:EditTimeoff' },
                },
                {
                    path: '/company/locations',
                    name: 'ListLocations',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/locations/List.vue'),
                    meta: { title: 'LA:Locations' },
                },
                {
                    path: '/company/locations/add',
                    name: 'AddLocations',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/locations/Add.vue'),
                    meta: { title: 'LA:AddLocations' },
                },
                {
                    path: '/company/locations/:id',
                    name: 'EditLocations',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/locations/Edit.vue'),
                    meta: { title: 'LA:EditLocations' },
                },
                {
                    path: '/company/departments',
                    name: 'ListDepartments',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/departments/List.vue'),
                    meta: { title: 'LA:Departments' },
                },
                {
                    path: '/company/departments/add',
                    name: 'AddDepartments',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/departments/Add.vue'),
                    meta: { title: 'LA:AddDepartment' },
                },
                {
                    path: '/company/departments/:id',
                    name: 'EditDepartments',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/departments/Edit.vue'),
                    meta: { title: 'LA:EditDepartment' },
                },
                {
                    path: '/company/workflows',
                    name: 'ListWorkflows',
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/workflows/List.vue'),
                    meta: { title: 'LA:Workflows' },
                },
                {
                    path: "/company/workflows/:id",
                    name: "EditWorkflow",
                    component: () => import(/*webpackChunkName:"company" */'@/views/protected/company/workflows/Edit.vue'),
                },
                {
                    path: '/company/calendars',
                    name: 'ListCalendars',
                    component: () => import(/* webpackChunkName:"company" */ '@/views/protected/company/calendar/Calendar.vue'),
                    meta: { title: 'LA:Calendars' },
                },
                {
                    path: "/membership",
                    name: Component.Protected.Company.Membership.List,
                    component: () => import(/*webpackChunkName:"membership" */ "@/views/protected/membership/Membership.vue"),
                    meta: { title: "LA:Membership" }
                },
                {
                    path: '/benefit/list',
                    name: Component.Protected.Benefit.List,
                    component: () => import(/*webpackChunkName:"benefit" */ '@/views/protected/benefit/List.vue'),
                    meta: { title: 'LA:Benefits' },
                },
                {
                    path: '/benefit/onboarding/:id',
                    name: Component.Protected.Benefit.OnBoarding,
                    component: () => import(/*webpackChunkName:"benefit" */ '@/views/protected/benefit/Onboarding.vue'),
                    meta: { title: 'LA:BenefitDetails' },
                },
                {
                    path: '/benefit/pension/add',
                    name: Component.Protected.Benefit.Pension.Add,
                    component: () => import(/*webpackChunkName:"pension" */'@/views/protected/benefit/add/Pension.vue'),
                    meta: { title: 'LA:AddPension' },
                },
                {
                    path: '/benefit/pension/:id',
                    name: Component.Protected.Benefit.Pension.Edit,
                    component: () => import(/*webpackChunkName:"pension" */'@/views/protected/benefit/edit/Pension.vue'),
                    meta: { title: 'LA:EditPension' },
                },
                {
                    path: '/benefit/insurance/add',
                    name: Component.Protected.Benefit.Insurance.Add,
                    component: () => import(/*webpackChunkName:"insurance" */'@/views/protected/benefit/add/Insurance.vue'),
                    meta: { title: 'LA:AddInsurance' },
                },
                {
                    path: '/benefit/insurance/:id',
                    name: Component.Protected.Benefit.Insurance.Edit,
                    component: () => import(/*webpackChunkName:"insurance" */'@/views/protected/benefit/edit/Insurance.vue'),
                    meta: { title: 'LA:EditInsurance' },
                },
                {
                    path: '/benefit/custom/add',
                    name: Component.Protected.Benefit.Custom.Add,
                    component: () => import(/*webpackChunkName:"custom" */'@/views/protected/benefit/add/Custom.vue'),
                    meta: { title: 'LA:AddBenefit' },
                },
                {
                    path: '/benefit/custom/:id',
                    name: Component.Protected.Benefit.Custom.Edit,
                    component: () => import(/*webpackChunkName:"custom" */'@/views/protected/benefit/edit/Custom.vue'),
                    meta: { title: 'LA:EditBenefit' },
                },
                {
                    path: '/benefit/marketplace',
                    name: Component.Protected.Benefit.Marketplace,
                    component: () => import(/*webpackChunkName:"marketplace" */'@/views/protected/benefit/marketplace/List.vue'),
                    meta: { title: 'LA:BenefitMarketplace' },
                },
                {
                    path: '/provider',
                    name: Component.Protected.Benefit.Provider.Info,
                    component: () => import(/*webpackChunkName:"marketplace" */'@/views/protected/benefit/provider/provider.vue'),
                    meta: { title: 'LA:Provider Management' },
                },
                {
                    path: '/provider/:id',
                    name: Component.Protected.Benefit.Provider.Profile,
                    component: () => import(/*webpackChunkName:"marketplace" */'@/views/protected/benefit/provider/profile.vue'),
                    meta: { title: 'LA:Provider Profile' },
                },
                {
                    path: '/announcements',
                    name: Component.Protected.Announcement.List,
                    component: () => import(/*webpackChunkName:"announcements"*/ '@/views/protected/announcement/Announcement.vue'),
                    meta: { title: 'LA:Announcements' },
                },
                {
                    path: '/announcements/add',
                    name: Component.Protected.Announcement.Add,
                    component: () => import(/*webpackChunkName:"announcements" */ '@/views/protected/announcement/Add.vue'),
                    meta: { title: 'LA:AddAnnouncement' },
                },
                {
                    path: '/announcements/edit/:id',
                    name: Component.Protected.Announcement.Edit,
                    component: () => import(/*webpackChunkName:"announcements" */ '@/views/protected/announcement/Edit.vue'),
                },
                {
                    path: '/announcements/:id',
                    name: Component.Protected.Announcement.Read,
                    component: () => import(/*webpackChunkName:"announcements" */ '@/views/protected/announcement/ReadOnly.vue'),
                    meta: { title: 'LA:ReadAnnouncement' },
                },
                {
                    path: '/backoffice',
                    name: Component.Protected.Backoffice.List,
                    component: () => import(/*webpackChunkName:"backoffice"*/ '@/views/protected/backoffice/Backoffice.vue'),
                    meta: { title: 'LA:Backoffice' },
                },
                {
                    path: '/backoffice/add',
                    name: Component.Protected.Backoffice.Add,
                    component: () => import(/*webpackChunkName:"backoffice" */ '@/views/protected/backoffice/Add.vue'),
                    meta: { title: 'LA:AddBackoffice' },
                },
                {
                    path: '/backoffice/edit/:id',
                    name: Component.Protected.Backoffice.Edit,
                    component: () => import(/*webpackChunkName:"backoffice" */ '@/views/protected/backoffice/Edit.vue'),
                    meta: { title: 'LA:EditBackoffice' },
                },
                {
                    path: '/backoffice/:id',
                    name: Component.Protected.Backoffice.Read,
                    component: () => import(/*webpackChunkName:"backoffice" */ '@/views/protected/backoffice/ReadOnly.vue'),
                    meta: { title: 'LA:ReadBackoffice' },
                },
                {
                    path: '/company/access-logs',
                    name: Component.Protected.Company.Access.Logs,
                    component: () => import(/*webpackChunkName:"access" */ '@/views/protected/company/access/AccessLogs.vue')
                },
                {
                    path: '/company/access',
                    name: Component.Protected.Company.Access.List,
                    component: () => import(/*webpackChunkName:"access" */ '@/views/protected/company/access/AccessManagement.vue')
                },
                {
                    path: '/company/workflow-todos',
                    name: Component.Protected.Company.WorkflowToDos.List,
                    component: () => import(/*webpackChunkName:"workflowToDos" */ '@/views/protected/company/WorkflowToDos/List.vue')
                }
            ]
        },
    ]
};
const router = new Router(option);

router.beforeEach((to, from, next) => {
    const currentUser = appAuth.currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) { // if the current user is not logged in and protected route
        next({ name: "Login" });
    } else if (!requiresAuth && currentUser) {
        next({ name: "Dashboard" });
    } else {
        next()
    }
});

export default router;
